import { API_URL, getHeaders } from "../../utils/contextHelpers";
import { api, request, buildQuery } from "./core";

export const getBannersAll = api("getBannersAll", ({ canal = "" } = {}) => {
    const params = new URLSearchParams();
    if (canal) params.set("canal", canal);
    const query = params.toString();
    return `${API_URL}banners/all${query ? `?${query}` : ""}`;
});

export const refreshBannersCache = api("refreshBannersCache", () => `${API_URL}cache/banners/refresh`);

export const insertarBanner = (formData) => {
    const headers = getHeaders();
    headers.delete("Content-Type");
    return request(`${API_URL}banners/insertar`, {
        method: "POST",
        headers,
        body: formData,
    }).then((res) => refreshBannersCache().then(() => res));
};

export const editarBanner = (formData) => {
    const headers = getHeaders();
    headers.delete("Content-Type");
    return request(`${API_URL}banners/editar`, {
        method: "POST",
        headers,
        body: formData,
    }).then((res) => refreshBannersCache().then(() => res));
};

export const activarBanner = (id, activa) =>
    api("activarBanner", () => `${API_URL}banners/activar?${buildQuery({ id, activa: activa ? 1 : 0 })}`)()
        .then((res) => refreshBannersCache().then(() => res));

export const eliminarBanner = (id) =>
    api("eliminarBanner", () => `${API_URL}banners/eliminar?${buildQuery({ id })}`)()
        .then((res) => refreshBannersCache().then(() => res));
